var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.290573H30V20.2902H0V0.290573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66103H30V13.9197H0V6.66103Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.290573H30V3.48522H0V0.290573ZM0 17.0958H30V20.2905H0V17.0958Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white",
    transform: "translate(0 0.290527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThLanguage);
export default __webpack_public_path__ + "static/media/thLanguage.8afc7ae693f26cee27aeba73d3cb0312.svg";
export { ForwardRef as ReactComponent };